
import { defineComponent, ref, computed, watch } from 'vue';

export default defineComponent({
  name: 'PlatformLogsPagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  emits: ['page-change', 'page-size-change'],
  setup(props, { emit }) {
    const currentPage = ref(props.page);
    const currentPageSize = ref(props.pageSize);

    const pageSizeOptions = [10, 25, 50, 100];

    const startItem = computed(() => {
      return props.totalItems === 0 ? 0 : (props.page - 1) * props.pageSize + 1;
    });

    const endItem = computed(() => {
      const end = props.page * props.pageSize;
      return end > props.totalItems ? props.totalItems : end;
    });

    const onPageChange = (page: number) => {
      emit('page-change', page);
    };

    const onPageSizeChange = (pageSize: number) => {
      emit('page-size-change', pageSize);
    };

    // Watch for external changes
    watch(() => props.page, (newPage) => {
      currentPage.value = newPage;
    });

    watch(() => props.pageSize, (newPageSize) => {
      currentPageSize.value = newPageSize;
    });

    return {
      currentPage,
      currentPageSize,
      pageSizeOptions,
      startItem,
      endItem,
      onPageChange,
      onPageSizeChange,
    };
  },
});
